import { replace } from 'connected-react-router';
import {
    ACTION_TO_ADD_ANSWER,
    ACTION_TO_ADD_COMMENT,
    ACTION_TO_TURN_NOTIFICATIONS_ON,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_POST,
    ENTER_NEW_POSITION_OF_COMMENT,
    EXPLAIN_COMMENT_DELETION,
    EXPLAIN_POST_DELETION,
    FORUM_POST_PINNED,
    FORUM_POST_UNPINNED,
    FORUM_TURNED_OFF_NOTIFICATIONS_FOR_NEW_ANSWERS,
    FORUM_TURNED_ON_NOTIFICATIONS_FOR_NEW_ANSWERS,
} from 'mk/autogenerated/translations/PostDetail.sagas.3c7aa581290c8a2da66677349bc5e563'
import { isAnonymousUser, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import {
    forum_api_comment_create_url,
    forum_api_delete_comment_url,
    forum_api_delete_post_url,
    forum_api_move_up_comment_url,
    forum_api_post_detail_url,
    forum_api_post_pin_url,
    forum_api_post_unpin_url,
    wall_api_set_follow_url,
} from 'mk/urls/functions';
import { COMMENT_CREATE_FORM_NAME } from 'mk2/apps/forum/components/CommentCreateEditForm';
import {
    editableDisable,
    postDetailCommentCreateApi,
    postDetailCommentDeleteApi,
    postDetailDeletePostApi,
    postDetailFetchApi,
    postDetailMoveUpCommentApi,
    postDetailPostStickyApi,
    postDetailScrollToTrigger,
    postDetailToggleNotificationsActions,
    postDetailUpdateInBackgroundTrigger,
    CommentCreateNormalizedResponse,
    PostDetailCommentCreateTriggerAction,
    PostDetailCommentDeleteNormalizedResponse,
    PostDetailCommentDeleteTriggerAction,
    PostDetailCommentReplyAction,
    PostDetailDeletePostAction,
    PostDetailFetchNormalizedResponse,
    PostDetailFetchTriggerAction,
    PostDetailMoveUpCommentAction,
    PostDetailPostStickyAction,
    PostDetailScrollToTriggerAction,
    PostDetailToggleNotificationsAction,
    PostDetailTrackTriggerAction,
    PostDetailUpdateInBackgroundTriggerAction,
    POST_DETAIL_ADD_COMMENT_UNAUTHENTICATED,
    POST_DETAIL_COMMENT_CREATE_TRIGGER,
    POST_DETAIL_COMMENT_DELETE_TRIGGER,
    POST_DETAIL_COMMENT_REPLY,
    POST_DETAIL_DELETE_POST,
    POST_DETAIL_FETCH_TRIGGER,
    POST_DETAIL_MOVE_UP_COMMENT,
    POST_DETAIL_POST_STICKY,
    POST_DETAIL_SCROLLTO_TRIGGER,
    POST_DETAIL_TOGGLE_NOTIFICATIONS,
    POST_DETAIL_TRACK_TRIGGER,
    POST_DETAIL_UPDATE_IN_BACKGROUND_TRIGGER,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.actions';
import { PostDetailPageState, PostDetailState } from 'mk2/apps/forum/containers/PostDetail/PostDetail.reducers';
import {
    getForumPostDetailPageState,
    getForumPostDetailState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.selectors';
import { ScrollToPosition } from 'mk2/apps/forum/containers/PostDetail/PostDetailPage';
import { postDetailUrl } from 'mk2/apps/forum/helpers';
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    ContestEntity,
    ContestSchema,
    ForumMessageSchema, MyAnonymousCommentEntity, MyAnonymousCommentSchema,
    MyAnonymousPostEntity,
    MyAnonymousPostSchema,
    PostEntity,
    PostSchema,
} from 'mk2/apps/forum/schemas';
import { forumPostDetailUrl } from 'mk2/apps/forum/urls';
import { getPageNumberInPost } from 'mk2/apps/forum/utils';
import { gtmEvent } from 'mk2/apps/users/utils';
import { toolbarCloseAll } from 'mk2/containers/Toolbar/Toolbar.actions';
import {
    handleXHRGetErrorSaga,
    handleXHRPostErrorSaga,
    normalizeError,
    XHRAction,
    XHRFormError,
    XHRGetError,
    XHRPostError,
} from 'mk2/helpers/api';
import { autoFocusElement, handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from 'mk2/helpers/form';
import { PhotoUploadStatus } from 'mk2/helpers/form.reducers';
import { scrollDocumentTo, scrollElementTo } from 'mk2/helpers/scrolling';
import { showSuccessToast } from 'mk2/helpers/toasts';
import { tupdate } from 'mk2/helpers/types';
import { removeEmpty, removePage1, url } from 'mk2/helpers/urls';
import { getLogger } from 'mk2/logger';
import { getRequestDeviceIsIOS, getRequestDeviceMobile, getRequestUser, AppState } from 'mk2/reducers';
import { checkIfUserIsLoggedIn } from 'mk2/sagas/auth';
import { CommentEntity } from 'mk2/schemas';
import { getDenormalizedEntities, getDenormalizedEntity, getRoutingLocation } from 'mk2/selectors';
import { JamNotificationAction, JAM_NOTIFICATION } from 'mk2/services/jam.actions';
import { normalize } from 'normalizr';
import { parse } from 'query-string';
import { change, formValueSelector } from 'redux-form';
import { all, call, delay, put, select, takeEvery, takeLatest, throttle } from 'redux-saga/effects';
import { isNumber } from 'util';

const logger = getLogger('forum/PostDetail.sagas');

interface ApiResponsePosts {
    body: {
        entities: PostDetailFetchNormalizedResponse['entities'];
        result: PostDetailFetchNormalizedResponse['result'];
        page: number;
        numberOfPages: number;
        notificationsOn: number[];
        contestAlreadyParticipated: boolean;
        isMyAnonymousPost: boolean;
        brandDays: { posts: PostEntity[]; campaign: BrandDaysCampaignEntity; };
        myAnonymousComments: MyAnonymousCommentEntity[];
        userCanHavePregnancyNewsletter: boolean;
        isTitleEditableOnceAgain: boolean;
    };
}

function normalizePostDetailFetchResponse(body: ApiResponsePosts['body']): PostDetailFetchNormalizedResponse {
    // TODO: Rewrite when brandDays will be denormalized
    const normalizedResponse = normalize({
        brandDays: body.brandDays,
        myAnonymousComments: body.myAnonymousComments,
    }, {
        brandDays: { posts: [PostSchema], campaign: BrandDaysCampaignSchema },
        myAnonymousComments: [MyAnonymousCommentSchema],
    });

    // TODO: Remove when related items will be normalized on server
    const mergedResponse = {
        // Deep merge
        entities: Object.keys(body.entities).reduce((acc, cur) => {
            acc[cur] = {
                ...acc[cur],
                ...body.entities[cur],
            };
            return acc;
        }, normalizedResponse.entities),
        result: {
            ...normalizedResponse.result,
            ...body.result,
        },
    };
    return mergedResponse;
}

function* fetchPostDetail({ topicSlug, postSlug, pageRef, currentUrl, numCommentsBeforeLoad, xhr }: PostDetailFetchTriggerAction & XHRAction) {
    const query = parse(currentUrl.search);
    const brandDaysCampaign = query.with_brand_days_campaign as string;
    if (!pageRef) {
        // if pageRef is 0, negative or invalid string, we redirect us to page=1
        const gotoUrl = url(forumPostDetailUrl, {topicSlug, postSlug}, removeEmpty(removePage1({...query, page: 1})));
        yield put(replace(gotoUrl));
        return;
    } else if (pageRef && query.page && query.page !== pageRef.toString()) {
        // if we succeed parsing incorrect string (e.g. page=3a), then redir to correct page (e.g. page=3)
        const gotoUrl = url(forumPostDetailUrl, {topicSlug, postSlug}, removeEmpty(removePage1({...query, page: pageRef})));
        yield put(replace(gotoUrl));
        return;
    }

    if (numCommentsBeforeLoad > 0 && query.scrollto) {
        // if data is already loaded, scroll to bottom immediately
        // so that user does not experience scroll delayed by api call
        yield put(postDetailScrollToTrigger(query.scrollto as ScrollToPosition));
    }

    yield put(postDetailFetchApi.request(topicSlug, postSlug, pageRef, brandDaysCampaign));

    try {
        const response: ApiResponsePosts = yield call(
            () => xhr.get(forum_api_post_detail_url(topicSlug, postSlug), {page: pageRef, brandDays: brandDaysCampaign }),
        );

        // ak skusame nahravat zly page number (negativny, vacsi ako pocet stranok, atd.), backend nas redirectne
        if (isNumber(pageRef) && pageRef !== response.body.page) {
            throw new Error('Wrong page');
        }

        const normalizedResponse: PostDetailFetchNormalizedResponse = normalizePostDetailFetchResponse(response.body);

        yield put(postDetailFetchApi.success(
            topicSlug, postSlug, pageRef,
            response.body.page,
            response.body.numberOfPages,
            response.body.notificationsOn,
            response.body.isMyAnonymousPost,
            response.body.myAnonymousComments.map((c) => c.id),
            response.body.contestAlreadyParticipated,
            response.body.userCanHavePregnancyNewsletter,
            response.body.isTitleEditableOnceAgain,
            normalizedResponse,
        ));

        if (pageRef === 'last') {
            // replace page='last' with real page index
            const gotoUrl = url(forumPostDetailUrl, {topicSlug, postSlug}, removeEmpty(removePage1({...query, page: response.body.page})));
            yield put(replace(gotoUrl));
        } else if (query.page === '1') {
            // remove ?page=1 from url
            const gotoUrl = url(forumPostDetailUrl, {topicSlug, postSlug}, removeEmpty(removePage1({...query, page: 1})));
            yield put(replace(gotoUrl));
        }

        const numCommentsAfterLoad = response.body.result.comments?.length ?? 0;
        if (numCommentsBeforeLoad !== numCommentsAfterLoad && query.scrollto) {
            // other count of comments, either first load, or data on server changed, so scroll again
            yield put(postDetailScrollToTrigger(query.scrollto as ScrollToPosition));
        }

    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(postDetailFetchApi.failure(topicSlug, postSlug, pageRef, normalizeError(error)));
    }
}

function* scrolltoPostDetail({ scrollto }: PostDetailScrollToTriggerAction) {
    if (scrollto === ScrollToPosition.LastComment) {
        scrollElementTo('#scrolltoLastHere', 'window-bottom', 150);
    } else if (scrollto === ScrollToPosition.FirstComment) {
        scrollElementTo('#scrolltoFirstHere', 'window-top', 150);
    }
}

function* updatePostDetailInBackground({ topicSlug, postSlug, pageRef, currentUrl, xhr }: PostDetailUpdateInBackgroundTriggerAction & XHRAction) {
    const query = parse(currentUrl.search);
    const brandDaysCampaign = query.with_brand_days_campaign as string;
    yield put(postDetailFetchApi.request(topicSlug, postSlug, pageRef, brandDaysCampaign));

    try {
        const response: ApiResponsePosts = yield call(
            () => xhr.get(forum_api_post_detail_url(topicSlug, postSlug), {page: pageRef}),
        );

        const normalizedResponse: PostDetailFetchNormalizedResponse = normalizePostDetailFetchResponse(response.body);

        yield put(postDetailFetchApi.success(
            topicSlug, postSlug, pageRef,
            response.body.page,
            response.body.numberOfPages,
            response.body.notificationsOn,
            response.body.isMyAnonymousPost,
            response.body.myAnonymousComments.map((c) => c.id),
            response.body.contestAlreadyParticipated,
            response.body.userCanHavePregnancyNewsletter,
            response.body.isTitleEditableOnceAgain,
            normalizedResponse,
        ));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(postDetailFetchApi.failure(topicSlug, postSlug, pageRef, normalizeError(error)));
    }
}

export interface ApiResponseCommentCreate {
    body: {
        comment: CommentEntity;
        post: PostEntity;
        contest: ContestEntity;
        contestAlreadyParticipated: boolean;
        targetPostCommercialDetails: {
            /**
             * keep format in sync with export.py
             */
            relatedToDaysWith: string[],
            relatedToAmbassadorOfBrands: number[],
            relatedToTesting: string[],
        };
    };
}

function* commentCreate({ postId, commentFd, xhr }: PostDetailCommentCreateTriggerAction & XHRAction) {
    const isMobile = yield select(getRequestDeviceMobile);
    const isIOS = yield select(getRequestDeviceIsIOS);
    const post: PostEntity = yield select((state: AppState) => getDenormalizedEntity<PostEntity>(state, PostSchema, postId));
    const reducerKey = `${post.topic.slug}/${post.slug}`;
    const location = yield select(getRoutingLocation);
    const query = parse(location.search, { parseNumbers: true });
    const currentPage = query.page as number || 1;

    yield put(postDetailCommentCreateApi.request(postId, commentFd, reducerKey));
    try {
        const response: ApiResponseCommentCreate = yield call(
            () => xhr.post(forum_api_comment_create_url(), {
                postId,
                commentData: tupdate(commentFd, {
                    photos: commentFd.photos ? commentFd.photos.filter((photo) => photo.status === PhotoUploadStatus.SUCCESS) : [],
                }),
            }),
        );

        const normalizedResponse: CommentCreateNormalizedResponse = normalize(response.body, {
            comment: ForumMessageSchema,
            myAnonymousComment: ForumMessageSchema,
            post: PostSchema,
            contest: ContestSchema,
        });

        // close toolbar, e.g. photos might be opened
        yield put(toolbarCloseAll(COMMENT_CREATE_FORM_NAME));

        const nextPage = getPageNumberInPost(response.body.comment);
        const gotoUrl = true || nextPage !== currentPage
            ? postDetailUrl(
                post,
                removePage1(tupdate(query as { [key: string]: number | string }, {page: nextPage})),
                `comment-${response.body.comment.id}`,
            )
            // zostan na tej istej url
            : null;

        gtmEvent('event_post_detail_comment_create');
        yield handleXHRFormSuccessSaga(COMMENT_CREATE_FORM_NAME, gotoUrl);
        yield put(postDetailCommentCreateApi.success(
            postId,
            commentFd,
            reducerKey,
            response.body.contestAlreadyParticipated,
            normalizedResponse,
        ));

        // scroll to the bottom on mobile so user can see what his/her comment looks like
        if (isMobile && !gotoUrl && !isIOS) {
            scrollDocumentTo('bottom');
        }
    } catch (error) {
        yield handleXHRFormErrorSaga(COMMENT_CREATE_FORM_NAME, error as XHRFormError, logger);
        yield put(postDetailCommentCreateApi.failure(postId, commentFd, reducerKey, normalizeError(error)));
    }
}

function* commentReply({ username, textArea, repliedToCommentId }: PostDetailCommentReplyAction) {
    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_ADD_ANSWER))) {
        return;
    }
    const text = (yield select(formValueSelector(COMMENT_CREATE_FORM_NAME), 'text')) ?? '';
    const mention = username ? '@' + username + ' ' : '';
    const value = text + (text && mention ? '\n' : '') + mention;
    // Change form
    yield put(change(COMMENT_CREATE_FORM_NAME, 'text', value));
    if (repliedToCommentId) {
        yield put(change(COMMENT_CREATE_FORM_NAME, 'repliedToMessageId', repliedToCommentId));
    }

    const isMobile = yield select(getRequestDeviceMobile);
    const isIOS = yield select(getRequestDeviceIsIOS);
    if (!isMobile && !isIOS)  {
        // na firefoxe, edge nestaci zavolat len focus() na textarea,
        // (nenascrolluju tak, aby cela textarea bola viditelna)
        textArea.scrollIntoView(true);
    }
    autoFocusElement(textArea, 'end', textArea.value);
}

interface ApiResponseDeleteComment {
    body: {
        comment: CommentEntity,
        post: PostEntity,
    };
}

function* postDetailDeleteComment({ id, xhr }: PostDetailCommentDeleteTriggerAction & XHRAction) {
    const requestUser = yield select(getRequestUser);
    const comment: CommentEntity = yield select((state: AppState) => getDenormalizedEntity<CommentEntity>(state, ForumMessageSchema, id));
    const myAnonymousPost: MyAnonymousPostEntity = yield select((state: AppState) => getDenormalizedEntity<MyAnonymousPostEntity>(state, MyAnonymousPostSchema, comment.postId));
    const isAuthor = myAnonymousPost
        ? isAnonymousUser(comment.authorUser)
        : isAuthenticatedAs(requestUser, comment.authorUser);
    let reason;

    if (isAuthor) {
        if (!window.confirm(ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT)) {
            return;
        }
    } else { // admin or moderator
        reason = window.prompt(EXPLAIN_COMMENT_DELETION);
        if (reason === null) {
            return;
        }
    }

    yield put(postDetailCommentDeleteApi.request(id));

    try {
        const response: ApiResponseDeleteComment = yield call(
            () => xhr.post(forum_api_delete_comment_url(id), isAuthor ? {} : { comment: reason }),
        );

        const normalizedResponse: PostDetailCommentDeleteNormalizedResponse = normalize(response.body, {
            comment: ForumMessageSchema,
            post: PostSchema,
        });
        yield put(postDetailCommentDeleteApi.success(id, normalizedResponse));

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(postDetailCommentDeleteApi.failure(id, normalizeError(error)));
    }
}

function* postDetailDisableEdit({itemId}: PostDetailTrackTriggerAction) {
    const query = parse(location.search);
    const currentPage = parseInt(query.page as string, 10) || 1;
    yield delay(121000);
    yield put(editableDisable(itemId, currentPage));
}

interface ApiResponseMoveUpComment {
    body: {
        comment: CommentEntity,
    };
}

function* postDetailMoveUpComment({ id, xhr }: PostDetailMoveUpCommentAction & XHRAction) {
    const newPosition = Number(window.prompt(ENTER_NEW_POSITION_OF_COMMENT));
    if (typeof newPosition !== 'number' && newPosition < 1) {
        return;
    }

    yield put(postDetailMoveUpCommentApi.request(id));

    try {
        const response: ApiResponseMoveUpComment = yield call(
            () => xhr.post(forum_api_move_up_comment_url(id), {newPosition}),
        );
        const normalizedResponse = normalize(response.body.comment, ForumMessageSchema);
        yield put(postDetailMoveUpCommentApi.success(id, normalizedResponse));
        location.reload();

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(postDetailMoveUpCommentApi.failure(id, normalizeError(error)));
    }
}

function* postDetailJam({ channel }: JamNotificationAction) {
    // Fetch last page of the post
    const postId = parseFloat(channel.replace('forum:post:', ''));
    const post: PostEntity = yield select(getDenormalizedEntity, PostSchema, postId);
    if (!post) {
        return;
    }

    const postDetailState = yield select(getForumPostDetailState, post.topic.slug, post.slug);
    const location = yield select(getRoutingLocation);
    if (postDetailState.numberOfPages !== null) {
        yield put(postDetailUpdateInBackgroundTrigger(post.topic.slug, post.slug, postDetailState.numberOfPages, location));
    }
}

function* forumAddReplyUnauthenticated() { /* this saga runs only in case the user is not logged in */
    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_ADD_COMMENT))) {
        return;
    }
}

function* postSticky({ postId, sticky, xhr }: PostDetailPostStickyAction & XHRAction) {
    yield put(postDetailPostStickyApi.request(postId, sticky));

    try {
        const response = yield call(
            () => xhr.post(
                sticky
                    ? forum_api_post_pin_url(postId)
                    : forum_api_post_unpin_url(postId),
            ),
        );

        const normalizedResponse = normalize(response.body, {post: PostSchema});
        yield put(postDetailPostStickyApi.success(postId, sticky, normalizedResponse));

        // Then display toast
        yield showSuccessToast(sticky ? FORUM_POST_PINNED : FORUM_POST_UNPINNED);
    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(postDetailPostStickyApi.failure(postId, sticky, normalizeError(error)));
    }
}

interface ApiResponseDeletePost {
    body: {
        post: PostEntity;
    };
}

function* deletePost({ id, xhr }: PostDetailDeletePostAction & XHRAction) {
    const requestUser = yield select(getRequestUser);
    const post: PostEntity = yield select((state: AppState) => getDenormalizedEntity<PostEntity>(state, PostSchema, id));
    const myAnonymousPost: MyAnonymousPostEntity = yield select((state: AppState) => getDenormalizedEntity<MyAnonymousPostEntity>(state, MyAnonymousPostSchema, id));
    const isAuthor = myAnonymousPost || isAuthenticatedAs(requestUser, post.author);
    let reason;

    if (isAuthor) {
        if (!window.confirm(ARE_YOU_SURE_YOU_WANT_TO_DELETE_POST)) {
            return;
        }
    } else { // admin or moderator
        reason = window.prompt(EXPLAIN_POST_DELETION);
        if (reason === null) {
            return;
        }
    }

    yield put(postDetailDeletePostApi.request(id));

    try {
        const response: ApiResponseDeletePost = yield call(
            () => xhr.post(forum_api_delete_post_url(id), isAuthor ? {} : { comment: reason }),
        );

        // Mark all comments for this post as deleted - so that visually change
        let comments: CommentEntity[] = [];
        const postState: PostDetailState = yield select(getForumPostDetailState, post.topic.slug, post.slug);
        if (postState && postState.numberOfPages) {
            for (let page = 1; page <= postState.numberOfPages; page++) {
                const postPageState: PostDetailPageState =
                    yield select(getForumPostDetailPageState, post.topic.slug, post.slug, page);
                const pageComments: CommentEntity[] =
                    yield select(getDenormalizedEntities, ForumMessageSchema, postPageState.commentIds);
                comments = comments.concat(pageComments);
            }
        }

        comments = comments.map((c) => (c.deletedAt ? c : {
            ...c,
            deletedAt: response.body.post.deletedAt,
        }));

        const normalizedResponse = normalize({
            post: response.body.post,
            comments,
        }, {
            post: PostSchema,
            comments: [ForumMessageSchema],
        });

        yield put(postDetailDeletePostApi.success(id, normalizedResponse));

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(postDetailDeletePostApi.failure(id, normalizeError(error)));
    }
}

interface ToggleNotificationsApiResponse {
    body: {
        follow: boolean;
    };
}

function* toggleNotifications({ username, channelName, channelId, follow, xhr }: PostDetailToggleNotificationsAction & XHRAction) {

    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_TURN_NOTIFICATIONS_ON))) {
        return;
    }

    yield put(postDetailToggleNotificationsActions.request());

    try {
        const response: ToggleNotificationsApiResponse = yield call(
            () => xhr.post(wall_api_set_follow_url(username), { channelName, channelId, follow }),
        );

        yield put(postDetailToggleNotificationsActions.success(response.body.follow, channelId));
        if (response.body.follow) {
            yield showSuccessToast(FORUM_TURNED_ON_NOTIFICATIONS_FOR_NEW_ANSWERS);
        } else {
            yield showSuccessToast(FORUM_TURNED_OFF_NOTIFICATIONS_FOR_NEW_ANSWERS);
        }

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(postDetailToggleNotificationsActions.failure(normalizeError(error)));

    }
}

export default function* root() {
    yield all([
        // musi byt takeEvery pre POST_DETAIL_FETCH_TRIGGER a nie takeLatest,
        // aby sa docitali vsekty stranky cez ktore rychlo pagujem. Inak sa killne
        // redux saga pocas jej vykonavania a loadingState ostane v stave Loading.
        // Ked sa na nu znova vratim, uz sa nezacne znova nacitavat, lebo nie je v stave Init
        takeEvery(POST_DETAIL_FETCH_TRIGGER, fetchPostDetail),
        takeLatest(POST_DETAIL_UPDATE_IN_BACKGROUND_TRIGGER, updatePostDetailInBackground),
        takeEvery(POST_DETAIL_COMMENT_CREATE_TRIGGER, commentCreate),
        takeLatest(POST_DETAIL_COMMENT_REPLY, commentReply),
        takeEvery(POST_DETAIL_COMMENT_DELETE_TRIGGER, postDetailDeleteComment),
        takeEvery(POST_DETAIL_MOVE_UP_COMMENT, postDetailMoveUpComment),
        takeEvery(POST_DETAIL_TRACK_TRIGGER, postDetailDisableEdit),
        takeEvery(POST_DETAIL_ADD_COMMENT_UNAUTHENTICATED, forumAddReplyUnauthenticated),
        takeEvery(POST_DETAIL_POST_STICKY, postSticky),
        takeLatest(POST_DETAIL_SCROLLTO_TRIGGER, scrolltoPostDetail),
        takeEvery(POST_DETAIL_DELETE_POST, deletePost),
        takeEvery(POST_DETAIL_TOGGLE_NOTIFICATIONS, toggleNotifications),
        throttle(
            30 * 1000, // wait 30s for next reload
            (action: JamNotificationAction) => action.type === JAM_NOTIFICATION && action.channel.startsWith('forum:post:'),
            postDetailJam,
        ),
    ]);
}
